/** Shared Benchmark number formatting — uses App Config currency / qty formats. */
import { formatAppMoney, formatAppQuantity } from '../../services/appConfigRuntime';

export const formatMoney = (v) => formatAppMoney(v);

export const formatNumber = (v, digits = 2) => {
  if (v == null || v === '') return '—';
  const n = Number(v);
  if (Number.isNaN(n)) return '—';
  // Prefer App Config quantity formatter; digits arg kept for call-site compat
  if (digits === 2 || digits === 3) return formatAppQuantity(n);
  return n.toLocaleString(undefined, {
    minimumFractionDigits: digits,
    maximumFractionDigits: digits,
  });
};

/** Prefer project name over code in dropdowns / chips / labels (boss UX). */
export const projectLabel = (p) => {
  if (!p) return '';
  const name = (p.projectName || '').trim();
  if (name) return name;
  return p.projectNumber || p.projectCode || String(p.projectId || p.id || '');
};

/** DataGrid column helpers for money / numeric cells. */
export const moneyColumn = (field, headerName, width = 130) => ({
  field,
  headerName,
  width,
  type: 'number',
  align: 'right',
  headerAlign: 'right',
  valueFormatter: (value) => formatMoney(value),
});

export const numberColumn = (field, headerName, width = 110, digits = 2) => ({
  field,
  headerName,
  width,
  type: 'number',
  align: 'right',
  headerAlign: 'right',
  valueFormatter: (value) => formatNumber(value, digits),
});
